var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 22,
    viewBox: "0 0 160 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.033 21.3663H152.935C152.716 21.3663 152.527 21.2865 152.368 21.1267C152.208 20.967 152.128 20.7773 152.128 20.5576V1.20861C152.128 0.98896 152.208 0.799264 152.368 0.639519C152.527 0.479775 152.716 0.399902 152.935 0.399902H159.033C159.252 0.399902 159.441 0.479775 159.601 0.639519C159.76 0.799264 159.84 0.98896 159.84 1.20861V20.5576C159.84 20.7773 159.76 20.967 159.601 21.1267C159.441 21.2865 159.252 21.3663 159.033 21.3663Z",
    fill: "url(#paint0_linear_5288_3347)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.597 0.399902H144.083C144.8 0.399902 145.249 0.729375 145.428 1.38832L152.094 20.4977C152.114 20.5576 152.123 20.6575 152.123 20.7972C152.123 20.917 152.054 21.0468 151.914 21.1866C151.795 21.3064 151.645 21.3663 151.466 21.3663H145.936C145.339 21.3663 144.95 21.1167 144.771 20.6175L144.053 18.6407H137.627L136.91 20.6175C136.73 21.1167 136.342 21.3663 135.744 21.3663H130.214C130.035 21.3663 129.875 21.3064 129.736 21.1866C129.616 21.0468 129.557 20.917 129.557 20.7972C129.557 20.6575 129.567 20.5576 129.587 20.4977L136.252 1.38832C136.431 0.729375 136.88 0.399902 137.597 0.399902Z",
    fill: "url(#paint1_linear_5288_3347)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.229 20.3779C124.289 20.4977 124.319 20.6275 124.319 20.7673C124.319 20.9071 124.249 21.0468 124.11 21.1866C123.99 21.3064 123.84 21.3663 123.661 21.3663H117.534C116.916 21.3663 116.488 21.0968 116.248 20.5576L113.678 14.8368H112.452V20.5576C112.452 20.7773 112.373 20.967 112.213 21.1267C112.054 21.2865 111.865 21.3663 111.645 21.3663H105.787C105.568 21.3663 105.379 21.2865 105.219 21.1267C105.06 20.967 104.98 20.7773 104.98 20.5576V1.20861C104.98 0.98896 105.06 0.799264 105.219 0.639519C105.379 0.479775 105.568 0.399902 105.787 0.399902H114.634C117.504 0.399902 119.746 1.04886 121.36 2.34678C122.974 3.62474 123.781 5.47178 123.781 7.88791C123.781 10.2841 122.705 12.1711 120.553 13.5488L124.229 20.3779ZM112.452 5.97098V9.1459H114.634C115.073 9.1459 115.412 9.00612 115.651 8.72657C115.89 8.42705 116.009 8.05764 116.009 7.61834C116.009 7.17905 115.89 6.79965 115.651 6.48017C115.431 6.14071 115.093 5.97098 114.634 5.97098H112.452Z",
    fill: "url(#paint2_linear_5288_3347)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7624 15.5257H102.969C103.188 15.5257 103.377 15.6056 103.536 15.7653C103.696 15.925 103.776 16.1147 103.776 16.3344V20.5576C103.776 20.7773 103.696 20.967 103.536 21.1267C103.377 21.2865 103.188 21.3663 102.969 21.3663H87.3959C87.1767 21.3663 86.9874 21.2865 86.828 21.1267C86.6686 20.967 86.5889 20.7773 86.5889 20.5576V1.20861C86.5889 0.98896 86.6686 0.799264 86.828 0.639519C86.9874 0.479775 87.1767 0.399902 87.3959 0.399902H102.729C102.949 0.399902 103.138 0.479775 103.297 0.639519C103.457 0.799264 103.536 0.98896 103.536 1.20861V5.43185C103.536 5.65149 103.457 5.84119 103.297 6.00093C103.138 6.16068 102.949 6.24055 102.729 6.24055H93.7624V8.12753H102.072C102.291 8.12753 102.48 8.2074 102.64 8.36714C102.799 8.52689 102.879 8.71658 102.879 8.93623V12.83C102.879 13.0496 102.799 13.2393 102.64 13.3991C102.48 13.5588 102.291 13.6387 102.072 13.6387H93.7624V15.5257Z",
    fill: "url(#paint3_linear_5288_3347)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.077 0.399902H75.6853C78.5946 0.399902 80.9858 1.12874 82.8589 2.5864C84.7519 4.0241 85.6984 6.04087 85.6984 8.63671V13.0996C85.6984 15.8152 84.7818 17.8719 82.9486 19.2697C81.1153 20.6674 78.7042 21.3663 75.7152 21.3663H68.1445C67.9253 21.3663 67.736 21.2865 67.5766 21.1267C67.4172 20.967 67.3375 20.7773 67.3375 20.5576L66.27 1.20861C66.27 0.98896 66.3497 0.799264 66.5091 0.639519C66.6686 0.479775 66.8579 0.399902 67.077 0.399902ZM73.7425 6.24055V15.5257H75.6853C76.3628 15.5257 76.9009 15.326 77.2994 14.9266C77.7178 14.5073 77.9271 13.8983 77.9271 13.0996V8.63671C77.9271 7.03927 77.1798 6.24055 75.6853 6.24055H73.7425Z",
    fill: "url(#paint4_linear_5288_3347)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1057 0.399902H72.5158C72.735 0.399902 72.9243 0.479775 73.0837 0.639519C73.2431 0.799264 73.3228 0.98896 73.3228 1.20861V20.5576C73.3228 20.7773 73.2431 20.967 73.0837 21.1267C72.9243 21.2865 72.735 21.3663 72.5158 21.3663H67.7932C67.2751 21.3663 66.8666 21.1367 66.5677 20.6774L61.5163 13.0397V20.5576C61.5163 20.7773 61.4366 20.967 61.2772 21.1267C61.1178 21.2865 60.9285 21.3663 60.7093 21.3663H55.2992C55.08 21.3663 54.8907 21.2865 54.7313 21.1267C54.5719 20.967 54.4922 20.7773 54.4922 20.5576V1.20861C54.4922 0.98896 54.5719 0.799264 54.7313 0.639519C54.8907 0.479775 55.08 0.399902 55.2992 0.399902H60.0218C60.5798 0.399902 60.9883 0.629535 61.2473 1.0888L66.2987 9.38551V1.20861C66.2987 0.98896 66.3784 0.799264 66.5378 0.639519C66.6972 0.479775 66.8865 0.399902 67.1057 0.399902Z",
    fill: "url(#paint5_linear_5288_3347)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6368 0.399902H52.4952C52.7144 0.399902 52.9037 0.479775 53.0631 0.639519C53.2225 0.799264 53.3022 0.98896 53.3022 1.20861V13.2493C53.3022 16.0448 52.4354 18.1515 50.7018 19.5692C48.9682 20.967 46.6994 21.3664 43.7105 21.3664C40.7414 21.3664 37.4578 21.6945 35.7042 20.2967C33.9706 18.8989 33.9336 16.0648 33.9336 13.2493V1.20861C33.9336 0.98896 34.0133 0.799264 34.1727 0.639519C34.3321 0.479775 34.5214 0.399902 34.7406 0.399902H40.599C40.8182 0.399902 41.0075 0.479775 41.1669 0.639519C41.3264 0.799264 41.4061 0.98896 41.4061 1.20861V13.3392C41.4061 14.8767 42.1433 15.6455 43.6179 15.6455C45.0925 15.6455 45.8298 14.8767 45.8298 13.3392V1.20861C45.8298 0.98896 45.9095 0.799264 46.0689 0.639519C46.2283 0.479775 46.4176 0.399902 46.6368 0.399902Z",
    fill: "url(#paint6_linear_5288_3347)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5455 0.399902H39.4039C39.6231 0.399902 39.8124 0.479775 39.9718 0.639519C40.1312 0.799264 40.2109 0.98896 40.2109 1.20861V20.5576C40.2109 20.7773 40.1312 20.967 39.9718 21.1267C39.8124 21.2865 39.6231 21.3663 39.4039 21.3663H33.5455C33.3263 21.3663 33.137 21.2865 32.9776 21.1267C32.8182 20.967 32.7385 20.7773 32.7385 20.5576V14.088H27.8963V20.5576C27.8963 20.7773 27.8166 20.967 27.6572 21.1267C27.4978 21.2865 27.3085 21.3663 27.0893 21.3663H21.2309C21.0117 21.3663 20.8224 21.2964 20.6629 21.1567C20.5035 20.9969 20.4238 20.7972 20.4238 20.5576V1.20861C20.4238 0.98896 20.5035 0.799264 20.6629 0.639519C20.8224 0.479775 21.0117 0.399902 21.2309 0.399902H27.0893C27.3085 0.399902 27.4978 0.479775 27.6572 0.639519C27.8166 0.799264 27.8963 0.98896 27.8963 1.20861V7.49853H32.7385V1.20861C32.7385 0.98896 32.8182 0.799264 32.9776 0.639519C33.137 0.479775 33.3263 0.399902 33.5455 0.399902Z",
    fill: "url(#paint7_linear_5288_3347)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64687 0.399902H19.1623C19.3815 0.399902 19.5708 0.479775 19.7302 0.639519C19.8897 0.799264 19.9694 0.98896 19.9694 1.20861V6.03089C19.9694 6.25053 19.8897 6.44023 19.7302 6.59997C19.5708 6.75972 19.3815 6.83959 19.1623 6.83959H14.2006V20.5576C14.2006 20.7773 14.1209 20.967 13.9615 21.1267C13.8021 21.2865 13.6128 21.3663 13.3936 21.3663H7.41562C7.19642 21.3663 7.00712 21.2865 6.84771 21.1267C6.6883 20.967 6.60859 20.7773 6.60859 20.5576V6.83959H1.64687C1.42768 6.83959 1.23838 6.75972 1.07896 6.59997C0.91955 6.44023 0.839844 6.25053 0.839844 6.03089V1.20861C0.839844 0.98896 0.91955 0.799264 1.07896 0.639519C1.23838 0.479775 1.42768 0.399902 1.64687 0.399902Z",
    fill: "url(#paint8_linear_5288_3347)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M141 9.02637C141.242 9.38579 141.518 9.71401 141.829 10C141.518 10.2858 141.242 10.6135 141 10.9727C140.758 10.6133 140.481 10.2859 140.17 10C140.481 9.71389 140.758 9.386 141 9.02637Z",
    fill: "#746BEB",
    stroke: "white",
    strokeWidth: 2.70391
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5288_3347",
    x1: -16.0687,
    y1: 2.64631,
    x2: 162.211,
    y2: 21.2895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E779B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5288_3347",
    x1: -16.0689,
    y1: 2.64631,
    x2: 162.211,
    y2: 21.2895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E779B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5288_3347",
    x1: -16.0693,
    y1: 2.64631,
    x2: 162.21,
    y2: 21.2895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E779B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5288_3347",
    x1: -16.0688,
    y1: 2.64631,
    x2: 162.211,
    y2: 21.2895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E779B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5288_3347",
    x1: -16.0696,
    y1: 2.64631,
    x2: 162.21,
    y2: 21.2895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E779B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5288_3347",
    x1: -7.5293,
    y1: 2.64631,
    x2: 170.75,
    y2: 21.2895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E779B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5288_3347",
    x1: -7.52927,
    y1: 2.64631,
    x2: 170.751,
    y2: 21.2896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E779B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5288_3347",
    x1: -0.0565703,
    y1: 2.64631,
    x2: 178.223,
    y2: 21.2895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E779B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5288_3347",
    x1: -0.0568525,
    y1: 2.64631,
    x2: 178.223,
    y2: 21.2895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E779B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ab7700662eda9da4be28b580f961700d.svg";
export { ForwardRef as ReactComponent };